import { useTranslation } from 'react-i18next';

import { ChevronRight } from 'lucide-react';

import { IconWithBackground } from '@/lib/shadcn/components/ui/icon-with-background/icon-with-background';
import { Stack } from '@/lib/shadcn/components/ui/stack/stack';
import { TileButton } from '@/lib/shadcn/components/ui/tile-button/tile-button';
import { cn } from '@/lib/shadcn/lib/utils';

import { ContactUsLinks } from './contact-us-links';
import { BaseDrawer } from '../base-drawer/base-drawer';

type ContactUsProps = {
  className?: string;
  buttonClassName?: string;
};

export function ContactUs({ className, buttonClassName }: ContactUsProps = {}) {
  const { t } = useTranslation();
  return (
    <BaseDrawer
      className={className}
      title={t('contact-us.title')}
      description={t('contact-us.description')}
      trigger={
        <TileButton
          background="default"
          paddingSize="medium"
          rightAddon={
            <IconWithBackground variant="secondary" icon={<ChevronRight />} size="lg" />
          }
          className={cn('w-full justify-between text-left text-p4', buttonClassName)}
          data-testid="communication-contacts-button"
        >
          {t('contact-us.label')}
        </TileButton>
      }
    >
      <Stack gap={2} className="pb-unit-13">
        <ContactUsLinks />
      </Stack>
    </BaseDrawer>
  );
}
